/* Dropdown behaviour for the collection filter row (.filter-container--top).
   The theme's <toggle-target> element already opens/closes each group on click;
   this adds: only one group open at a time, close on outside click / Escape,
   and re-open the group you were using after the ajax product refresh. */
(() => {
  const DESKTOP_MIN = 1000; // must match the CSS breakpoint
  const isDesktop = () => window.innerWidth >= DESKTOP_MIN;
  const OPEN = ':not(.toggle-target-toggler--is-hidden)';
  // Only the <toggle-target> headings are dropdown triggers. The "Sale" link and the
  // applied-filters heading share the .filter-group__heading class but must never be
  // clicked programmatically: .click() on the Sale <a> navigates to /collections/sale.
  const TRIGGER = 'toggle-target.filter-group__heading';

  const openHeadings = (root) => root.querySelectorAll(`${TRIGGER}${OPEN}`);
  const labelOf = (heading) => {
    const el = heading.querySelector('.filter-group__heading__text');
    return el ? el.textContent.trim() : '';
  };
  const closeAll = (root, except) => {
    openHeadings(root).forEach((h) => {
      if (h !== except) h.click();
    });
  };
  const openSilently = (heading) => {
    const target = document.querySelector(heading.dataset.toggleTarget);
    if (!target) return;
    target.classList.remove('toggle-target--hidden');
    heading.classList.remove('toggle-target-toggler--is-hidden');
    heading.setAttribute('aria-expanded', 'true');
  };

  const init = (container) => {
    if (container.dataset.topFiltersInit) return;
    container.dataset.topFiltersInit = 'true';
    let lastOpenLabel = null;

    // Runs after <toggle-target> has toggled the clicked heading (it listens on itself).
    container.addEventListener('click', (evt) => {
      if (!isDesktop()) return;
      const heading = evt.target.closest(TRIGGER);
      if (!heading || !container.contains(heading)) return;
      const nowOpen = !heading.classList.contains('toggle-target-toggler--is-hidden');
      lastOpenLabel = nowOpen ? labelOf(heading) : null;
      closeAll(container, heading);
    });

    // After the ajax refresh the filter markup is replaced: re-open the group in use.
    const inner = container.querySelector('.filters__inner');
    if (inner) {
      new MutationObserver(() => {
        if (!isDesktop() || !lastOpenLabel) return;
        const heading = Array.from(container.querySelectorAll(TRIGGER))
          .find((h) => labelOf(h) === lastOpenLabel);
        if (heading) openSilently(heading);
      }).observe(inner, { childList: true });
    }

    // Reset when leaving desktop so the mobile drawer isn't affected.
    window.addEventListener('resize', () => {
      if (!isDesktop()) lastOpenLabel = null;
    });
  };

  const containers = () => Array.from(document.querySelectorAll('.filter-container--top'));

  document.addEventListener('click', (evt) => {
    if (!isDesktop()) return;
    containers().forEach((c) => {
      const group = evt.target.closest('.filter-group');
      if (group && c.contains(group)) return; // click inside a trigger or its panel
      closeAll(c);
    });
  });
  document.addEventListener('keydown', (evt) => {
    if (evt.key === 'Escape' && isDesktop()) containers().forEach((c) => closeAll(c));
  });

  const boot = () => containers().forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
